
import React, { useEffect, useRef, useState } from 'react'
import Slider from "react-slick";
import { ArticleGet } from '../../api/orgService';
import { toast } from 'react-toastify';
import useApi from '../../api/useApi';

function NewsSection() {
  const { request: getAllArticles, data:articleData, error:articleError} = useApi(ArticleGet);
    
  useEffect(() => {
    getAllArticles();
         // eslint-disable-next-line
    }, []);
    
    useEffect(()=>{
      if (articleData?.status===200) {
        // setAllArticles(articleData?.data);
      }
    // eslint-disable-next-line
    },[articleData])

  
    // useEffect(()=>{
    //     if(location?.state?.refresh==="org"){
    //       getAllArticles();
    //     }
    //   // eslint-disable-next-line
    //   },[location?.state])
  
    useEffect(()=>{
        if(articleError){
            toast.error(`${JSON.stringify(articleError?.response?.data,null,2)}`,{position: "top-center"});
      }
    },[articleError]) 

    const newsItems = [

      {
        subtitle: "Maternal Health Crisis", 
        title: "Kenya faces 16 maternal deaths daily despite progress on healthcare investments", 
        date: "Report | 29 Oct 2025", 
        description: "Ministry of Health unveils Sh460 billion investment plan as maternal mortality remains at 355 deaths per 100,000 live births.",
        link:"https://www.standardmedia.co.ke/health-science/article/2001532939/kenya-steps-up-health-investments-to-safeguard-mothers-and-children#google_vignette",
        image:"https://file.fountainafrica.org/wp-content/uploads/2025/11/latest_news1.png",

      },{

        subtitle: "Postpartum Hemorrhage", 
        title: "Leading cause of maternal deaths accounts for 40% of mortality cases in Kenya", 
        date: "Report | 30 Sep 2025", 
        description: "High-level policy dialogue reveals preventable complications continue to claim lives as healthcare facilities lack essential supplies and trained staff.",
        link:"https://healthbusiness.co.ke/9616/national-health-reports-expose-critical-gaps-in-kenyan-healthcare-essential-commodities-stockouts-staff-shortages-and-inconsistent-lab-services",
        image:"https://file.fountainafrica.org/wp-content/uploads/2025/11/latest_news5.png"
      },
      {
        subtitle: "Healthcare Partnerships", 
        title: "UNFPA and M-Pesa Foundation launch initiative to transform maternal health outcomes", 
        date: "Report | 24 Jun 2025", 
        description: "New collaboration focuses on emergency obstetric care and digital health innovations in underserved regions across Kenya. ",
        link: "https://kenya.unfpa.org/en/news/unfpa-and-m-pesa-foundation-announce-collaborative-initiative-aimed-transforming-maternal-and",
        image:"https://file.fountainafrica.org/wp-content/uploads/2025/11/latest_news3.png",

      },

      {
        subtitle: "Newborn Health", 
        title: "Ministry intensifies EWENE Campaign to prevent maternal and newborn deaths", 
        date: "Report | 19 May 2025", 
        description: "New strategic communication initiative strengthens coordination on reproductive and maternal health across Kenyan counties.",
        link:"https://pmnch.who.int/news-and-events/news/item/19-02-2025-a-call-for-disruptive-advocacy-kenya-s-collaborative-advocacy-action-plan",
        image:"https://file.fountainafrica.org/wp-content/uploads/2025/11/latest_news4.png",
      
      },
      ];

  const carouselRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  const handleScroll = () => {
    const carousel = carouselRef.current;
    if (carousel) {
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      const progress = (carousel.scrollLeft / maxScroll) * 100;
      setScrollProgress(progress);
    }
  };

  const scrollNext = () => {
    const carousel = carouselRef.current;
    if (carousel) {
      carousel.scrollBy({ left: 350, behavior: "smooth" });
    }
  };

  const scrollPrev = () => {
    const carousel = carouselRef.current;
    if (carousel) {
      carousel.scrollBy({ left: -350, behavior: "smooth" });
    }
  };

  useEffect(() => {
    const carousel = carouselRef.current;
    if (carousel) {
      carousel.addEventListener("scroll", handleScroll);
      return () => carousel.removeEventListener("scroll", handleScroll);
    }
  }, []);


  return (
    <section className="news-news-carousel" >
      <h2 className="section-title" style={{color: "#eeeee"}}>Latest News</h2>
      <div className="news-carousel-container" ref={carouselRef}>
        <div className="news-carousel-news">
          {newsItems.map((item, index) => (
            <article className="news-news-card" key={index}>
              <div className="news-image-wrapper">
                <img src={item.image} alt={item.title} />
                <div className="news-icon">{item?.icon}</div>
              </div>
              <div className="news-content-news">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <div className="news-stats">
                  {/* {item.stats.map((s, i) => (
                    <div className="news-stat-box" key={i}>
                      <h4>{s.value}</h4>
                      <p>{s.label}</p>
                    </div>
                  ))} */}
                </div>
                <a href={item?.link} className="news-learn-more">
                  Learn More →
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
      {/* Carousel Controls */}
      <div className="news-carousel-controls">
        <button className="news-control-btn" onClick={scrollPrev}>
          ◀ 
        </button>

        <button className="news-control-btn" onClick={scrollNext}>
          ▶
        </button>
        <div className="news-progress-bar">
          <div
            className="news-progress-fill"
            style={{ width: `${scrollProgress}%` }}
          ></div>
        </div>
      </div>
    </section>

  )
}

export default NewsSection